module.exports = __webpack_public_path__ + "img/list_p.f8c00327.svg";